var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex align-center",staticStyle:{"margin-left":"2em"}},[_c('span',{style:(_vm.systemLocale === 'ru'
        ? _vm.styleActive
        : _vm.styleInactive),on:{"click":function($event){return _vm.changeLocale('ru')}}},[_vm._v(" Рус ")]),_c('span',{staticStyle:{"margin":"0 12px"}},[_vm._v(" | ")]),_c('span',{style:(_vm.systemLocale === 'en'
        ? _vm.styleActive
        : _vm.styleInactive),on:{"click":function($event){return _vm.changeLocale('en')}}},[_vm._v(" Eng ")])])}
var staticRenderFns = []

export { render, staticRenderFns }